import { z } from 'zod';

export const DatabaseWithVisibleRevision = z.object({
  databaseId: z.string(),
  databaseName: z.string(),
  revisionName: z.string(),
  databaseRevisionId: z.string(),
  isHidden: z.boolean(),
});

export type DatabaseWithVisibleRevision = z.infer<
  typeof DatabaseWithVisibleRevision
>;

export const DatabasesWithVisibleRevisions = z.array(
  DatabaseWithVisibleRevision,
);

export type DatabasesWithVisibleRevisions = z.infer<
  typeof DatabasesWithVisibleRevisions
>;
